exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-536fa780] .vc-container{border:none}", ""]);

// exports
